import React from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import { Div, Typography } from '@icecreamsocial/components';

import {
	QuerySearchBar,
	Pagename,
	PopsicleLoader,
} from '../../../../../../../../presentational';

import { InfluencerFiltersProvider } from './components/FilterProvider';
import FilterForm from './components/FilterForm';
import { Table } from './components/Table';
import { ExportButton } from './components/ExportButton';
import { useCampaign } from '../../../../providers/Campaign';

const InfluencerPerformance = () => {
	const { campaignId } = useParams();
	const { campaign } = useCampaign();
	const { data } = campaign;
	// const download = useDownloadLink();

	return (
		<InfluencerFiltersProvider>
			<Div display='flex'>
				<Div elWidth='75%' flexShrink='1' flexGrow='0'>
					<Div
						display='flex'
						alignItems='center'
						justifyContent='space-between'
					>
						<Pagename>Influencer Performance</Pagename>
						<ExportButton />
					</Div>
					<Div>
						<QuerySearchBar
							id='influencerSearch'
							name='search'
							placeholder='Find Influencers'
						/>
						{data ? (
							<Table campaignId={campaignId} campaign={data} />
						) : (
							<Div
								display='flex'
								padding='xlg'
								elMinHeight='300px'
								alignItems='center'
								justifyContent='center'
								flexDirection='column'
								backgroundColor='bodyInverse'
								borderRadius='default'
								borderColor='ambient'
								border='1px solid'
							>
								<PopsicleLoader />
								<Typography.P margin='none' textColor='ambientDark'>
									Just a moment...
								</Typography.P>
							</Div>
						)}
					</Div>
				</Div>
				<Div
					as='aside'
					elWidth='25%'
					marginLeft='lg'
					marginBottom='lg'
					flexShrink='1'
				>
					<Div position='sticky' positionTop='0'>
						<FilterForm />
					</Div>
				</Div>
			</Div>
		</InfluencerFiltersProvider>
	);
};

InfluencerPerformance.displayName =
	'Campaigns.Campaign.Reports.InfluencerPerformance';
export default observer(InfluencerPerformance);
